"use strict";

angular.module("vendor")
.component("enabledCheckbox", {
    templateUrl: require("./enabled-checkbox.component.html"),
    bindings: {
        model: "=",
        disableStatus: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/enabled-checkbox/enabled-checkbox.component.js
// module id = 801
// module chunks = 0